const makePage = (Component, ...hocs) => {
  return hocs.reduceRight((Comp, hoc) => hoc(Comp), Component);
};

export default makePage;
